import "@tamagui/polyfill-dev";
import * as React from "react";
globalThis.React ||= React;
typeof requestAnimationFrame > "u" && (globalThis.requestAnimationFrame = setImmediate);
//# sourceMappingURL=setup.js.map
